<template>
    <app-popover v-bind="$attrs" class="submit-form-wrapper" ref="popover" :inherit-width="viewSize.xsDown">
        <template #default="{toggle}">
            <form-input-submit name="action_save" :id="_id" :required="_required" class="submit-form button button-save" v-bind="$attrs" :disabled="disabled">
                <slot><i class="material-icons" aria-hidden="true" v-text="SubmitIcons.save" role="img"></i> <span>Speichern</span></slot>
            </form-input-submit><!-- --><span class="submit-form-extender button button-save" @click="toggle" @keydown.space.prevent @keyup.space.prevent="toggle"
            @keyup.prevent.space="toggle"
            @keyup.prevent.enter="toggle" ref="openSaveOptionsHandler"
            aria-label="Speicher-Optionen ausklappen" role="button" tabindex="0">
                <i class="material-icons no-padding" :class="{disabled}" aria-hidden="true" role="img">arrow_drop_down</i>
            </span>
        </template>
        <template #container>
            <div class="submit-buttons-wrapper">
                <slot name="options">
                    <div class="submit-button-row">
                        <form-input-submit size="long" name="save_list" class="button button-save" v-bind="$attrs" :disabled="disabled"
                            aria-label="Speichern und zur Liste" ref="saveToList">
                            <span aria-hidden="true">Speichern und zur Liste</span>
                        </form-input-submit>
                    </div>
                    <div class="submit-button-row">
                        <form-input-submit size="long" name="save_view" class="button button-save" v-bind="$attrs" :disabled="disabled"
                            aria-label="Speichern und zur Ansicht">
                            <span aria-hidden="true">Speichern und zur Ansicht</span>
                        </form-input-submit>
                    </div>
                </slot>
            </div>
        </template>
    </app-popover>
</template>

<script setup lang="ts">
    import {usePortuna} from '@/composables/portuna';
    import {SubmitIcons} from '@/library/design';
    import {FormRowKey} from '@/library/form';
    import {useStore} from 'vuex';
    import AppPopover from '../AppPopover.vue';
    import FormInputSubmit from './FormInputSubmit.vue';
    import {ref, onMounted, computed, inject, toRefs} from 'vue';

    const portuna = usePortuna();

    const store    = useStore();
    const viewSize = store.state.viewSize;

    const props = withDefaults(
        defineProps<{
            id?: string;
            disabled?: boolean;
            required?: boolean;
            overwriteRequired?: boolean;
        }>(),
        {
            required: false,
            overwriteRequired: false,
            disabled: false,
        },
    );

    const {
              id,
              disabled,
              required,
              overwriteRequired,
          } = toRefs(props);

    const parentFormRow = inject<Nullable<IFormRowContext>>(FormRowKey, null);

    const popover                = ref<AppPopover>();
    const saveToList             = ref<FormInputSubmit>();
    const openSaveOptionsHandler = ref<HTMLSpanElement>();

    const _required = computed(() =>
    {
        return required.value! || (!overwriteRequired.value! && parentFormRow?._required) || false;
    });

    const _id = computed(() =>
    {
        return id.value! || parentFormRow?.labelFor || null;
    });

    onMounted((): void =>
    {
        popover.value.emitter.on('open', () => saveToList.value?.triggerFocus());
        popover.value.emitter.on('close', () => openSaveOptionsHandler.value?.focus());
    });

    defineExpose(Object.assign({}, portuna, {
        componentName: 'FormInputSave',
    }));
</script>